import { useQueryApi } from 'utils/api'

import type { IInfoterkiniCategory } from 'types/info-terkini'

interface ResponseSuccessInfoTerkiniCategories {
  data: IInfoterkiniCategory[]
  meta: any
}

const apiPath = '/aum/announcement/v2/category/filter'

export function useAPIInfoTerkiniCategories() {
  return useQueryApi<ResponseSuccessInfoTerkiniCategories>(apiPath)
}
